document.addEventListener("DOMContentLoaded", function () {
  let currentRate = parseFloat(window.Shopify.currency.rate); 
  console.log("symbol", currencySymbol);

  if (currentMarket === "canada") {
    // Replace in collection showcase
    document.querySelectorAll('[class*="ai-collection-showcase__products"]').forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/\$([\d.,]+)/g, function (match, p1) {
        return currencySymbol + p1 + " CAD";
      });
    });

    // Function to replace in cart drawer
    function replaceInCartDrawer() {
      let cartDrawer = document.querySelector(".ocu-cart-drawer");
      if (cartDrawer) {
        cartDrawer.innerHTML = cartDrawer.innerHTML.replace(/\$([\d.,]+)/g, function (match, p1) {
          return currencySymbol + p1 + " CAD";
        });
      }
    }

    // Run when cart opens
    document.addEventListener("ocu:cart:open", replaceInCartDrawer);

    // Also run once on page load (in case cart is already visible)
    replaceInCartDrawer();


    document.querySelectorAll(".custom-comparison-price").forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/\$([\d.,]+)/g, function (match, p1) {
        // Convert string "1,234.56" → number 1234.56
        let price = parseFloat(p1.replace(/,/g, ""));

        // Multiply with Shopify conversion rate
        let convertedPrice = price * currentRate;

        // Round to nearest integer
        let roundedPrice = Math.round(convertedPrice);

        return currencySymbol + roundedPrice + " CAD";
      });
    });
  }
});


// <script>
// document.addEventListener("DOMContentLoaded", function () {
//   // expects these to be set in theme.liquid before this script:
//   //   window.currentMarket = '{{ localization.market.handle }}';
//   //   window.currencySymbol = '{{ cart.currency.symbol }}';

//   if (window.currentMarket !== "canada") return;

//   var SHOWCASE_SELECTOR = '[class*="ai-collection-showcase__products"]';
//   var PRICE_TARGETS = [
//     '.price',
//     '.money',
//     '.price-item',
//     '.product-card__price',
//     '.card__price',
//     '[data-price]'
//   ].join(',');

//   var priceRegex = /\$([\d.,]+)/g;

//   function updateShowcasePrices(root) {
//     var showcaseNodes = (root || document).querySelectorAll(SHOWCASE_SELECTOR);
//     showcaseNodes.forEach(function (wrap) {
//       var nodes = wrap.querySelectorAll(PRICE_TARGETS);
//       nodes.forEach(function (el) {
//         var original = el.textContent || '';
//         if (!original) return;

//         // prevent doubling "CAD" if already appended
//         if (/CAD\b/.test(original)) return;

//         var replaced = original.replace(priceRegex, function (match, amount) {
//           return (window.currencySymbol || '$') + amount + ' CAD';
//         });

//         if (replaced !== original) el.textContent = replaced;
//       });
//     });
//   }

//   // initial pass
//   updateShowcasePrices(document);

//   // (optional) re-run if the showcase content is re-rendered via JS (filters, pagination, etc.)
//   var showcaseRoot = document.querySelector(SHOWCASE_SELECTOR);
//   if (showcaseRoot) {
//     new MutationObserver(function (muts) {
//       // any child changes under the showcase -> re-apply
//       updateShowcasePrices(document);
//     }).observe(showcaseRoot.parentNode || showcaseRoot, { childList: true, subtree: true });
//   }
// });
// </script>
